import Cookies from "js-cookie"

export const checkIfBot = (): boolean => {
    const isBotCookieValue = Cookies.get("isBot")
    return isBotCookieValue === true.toString()
}
